export default {"src":"/_next/static/media/frames_for_dark_themes.f837b51d.svg","height":300,"width":300,"blurWidth":0,"blurHeight":0};